import { closePopup, getPopupRegistration, openPopup, Priority } from 'app/PopupHolder';
import userImg from 'assets/images/account-page/user-icon-lg.png';
import classNames from "classnames";
import Modal from 'components/base/Modal';
import React from 'react';
import { getBrandName } from 'utils/brand';
import UploadProfilePicture from '../components/uploadProfilePicture';
import { formatPhone } from 'data/user/constants';

import { Form, Formik } from "formik";
// import { isValidEmail, isValidPhone } from 'utils/validation';
import FormikText from '../components/Formik/FormikText';
import FormikCheckbox from '../components/Formik/FormikCheckbox';
import checkboxCSS from '../components/Formik/FormikCheckbox/style.scss';
import css from "../style.scss";

import { selectSelectedTeamMember , selectCardList , selectUserId, selectLeadAutomator} from "data/user/selectors";
import { useDispatch, useSelector } from 'react-redux';

import { getTeamMembers , updateTeamMember } from 'data/user/actions';
import apiService from 'data/user/apiService';
import { useMemo, useState } from 'react';
import CreditCardDropdown from '../components/CreditCardDropdown';
import { editProfileValidationSchema, getFullDataURL } from '../Team/validationSchemas';
import { useInvestorOutreachEntitlement } from '../Sections/useInvestorOutreachEntitlement';
import encryptPassword from 'utils/passwordValidation';
import { useEffect } from 'react';
import LeaveMessagePopup from './LeaveMessage';
import { getMarketingProfileValidationRules } from '../../../utils/validation';
import PasswordStrength from '../../../components/PasswordStrengthIndecator';

const EditTeamProfilePopup = (props) => {


    const teamMemberDetails = useSelector(selectSelectedTeamMember).toJS();

    const cardList = useSelector(selectCardList);
    const leadAutomator = useSelector(selectLeadAutomator);
    const hasListAutomatorSubscription = !!leadAutomator?.toJS?.()?.accountPlanMrcs?.length;

    const { entitled: hasInvestorOutreachSubscription } = useInvestorOutreachEntitlement(teamMemberDetails.userType === 'TEAM_FULL');

    const userID = useSelector(selectUserId)

    const [imageUrl, setImageUrl] = useState(teamMemberDetails ? teamMemberDetails?.profilePicture : '');
    const dispatch = useDispatch();
    const isBlankTM = !teamMemberDetails?.username;
    const editSchema = useMemo(() => editProfileValidationSchema(isBlankTM), [isBlankTM]);

    const validationRules = getMarketingProfileValidationRules();

    // Ensure `initialValues` contains a valid object
    const initialValues = {
        firstName: teamMemberDetails?.firstName || '',
        lastName: teamMemberDetails?.lastName || '',
        phone: formatPhone(teamMemberDetails?.phone) || '',
        username: teamMemberDetails?.username || '',
        confirmEmail: teamMemberDetails?.username || '',
        confirmPassword: '',
        propertyLimit: teamMemberDetails?.propertyLimit != null ? teamMemberDetails.propertyLimit : '',
        spendingLimit: teamMemberDetails?.spendingLimit != null ? teamMemberDetails.spendingLimit : '',
        teamMemberId: teamMemberDetails?.userId || '',
        primaryUserId: userID || null,
        agreeToTerms: true,
        type: teamMemberDetails?.userType || '',
        securityDomainId: 1,
        paymentMethodId: teamMemberDetails?.paymentMethodId || null,
        planMrcId: teamMemberDetails?.planMrcId || '',
        approvedAmount: teamMemberDetails?.approvedAmount || 30,
        profilePicture: teamMemberDetails?.profilePicture || [],
        newPwd : '',
        defaultSubsPaymentMethodId: teamMemberDetails?.defaultSubsPaymentMethodId || null,
        defaultInAppPaymentMethodId: teamMemberDetails?.defaultInAppPaymentMethodId || null,
        pushToBatchDialer: teamMemberDetails?.pushToBatchDialer || false,
        allowClickToDial: teamMemberDetails?.allowClickToDial || false,
        allowInvestorOutreach: teamMemberDetails?.allowInvestorOutreach || false,

    };



    const handleClose = () => {
        props.closePopup();
    };

    const handleTeamSubmit = async (values, cardCode = '') => {
        const cleanedPhone = values.phone?.replace(/\D/g, "");
        let updateValues = { ...initialValues, ...values,
            phone: cleanedPhone,
            username: values?.username?.trim().toLowerCase(),
            newPwd: encryptPassword(values?.newPwd),
         }
        let payload = updateValues

        if(teamMemberDetails.userType === 'SCOUT') {
            payload = {
                ...payload,
                approvedAmount: 0,
                defaultInAppPaymentMethodId: null,
                defaultSubsPaymentMethodId: null,
                paymentMethodId: null,
                profilePicture:  payload?.profilePicture ? payload?.profilePicture : [],
                pushToBatchDialer: false,
                allowClickToDial: false,
                allowInvestorOutreach: false
            };
            delete payload.propertyLimit;
            delete payload.spendingLimit;
        }
        if (teamMemberDetails?.userType === 'TEAM_FULL') {
            payload.pushToBatchDialer = payload?.pushToBatchDialer || false;
            payload.allowClickToDial = payload?.allowClickToDial || false;
            payload.allowInvestorOutreach = payload?.allowInvestorOutreach || false;
            if (cardCode) {
                payload.cardCode = cardCode;
            }
        }
        /**
         * If the user clears the username/email field and
         * they hit Save with it being blank,
         * then no changes to username/email should attempt to be saved.
         */
        if (!payload?.username) {
            payload.username = initialValues?.username;
        }

        delete payload?.confirmEmail
        delete payload?.confirmPassword
        // delete payload?.newPwd
        try {
            const response = await updateTeamMember(payload); // Await the async function
            if (response.success) {
                console.log("Update successful:", response.teamMember);
                dispatch(getTeamMembers(userID))
                handleClose()
            } else {
                console.error("Update failed:", response.error);
                dispatch(LeaveMessagePopup.open({
                  title: "Error",
                  message: response.error,
                  yesLable: "Ok",
                  cancelLable: null,
                  CancelRedirect: () => null,
                  yesRedirect: () => null
                }))
            }
        } catch (error) {
            console.error("Unexpected error:", error);
            dispatch(LeaveMessagePopup.open({
                title: "Error",
                message: error?.message || "Something went wrong!",
                yesLable: "Ok",
                cancelLable: null,
                CancelRedirect: () => null,
                yesRedirect: () => null
            }))
            }

    };


    const handleCardChange = (selectedOption, type, setFieldValue) => {
        console.log(selectedOption)
        setFieldValue(type, selectedOption?.paymentMethodId);
      }


    return (
        <Modal modalClassName={css.pricingModal} className={classNames(css.clsAccPageModals, css.clsBillingModal, css.clsAccEditMarketingProfileModal)} isOpen uniqId="EditMarketingProfilePopup" width="auto" padding="0px 0px 0px" onClose={handleClose}>
            <div className={classNames(css.modal_lg, "modal-dialog modal-lg m-0")}>
                <div className={classNames(css.clsModalContent, "modal-content w-100")}>
                    <div className={classNames(css.clsModalContentBody, teamMemberDetails.scoutUser ? css.teamModalBodyScoutUser : css.teamModalBody, "modal-body rounded")}>
                        <Formik
                            initialValues={initialValues}
                            validationSchema={editSchema}
                            validateOnChange={true}
                            validateOnBlur={true}
                            onSubmit={(values) => handleTeamSubmit(values)}
                        >
                            {({ touched, errors, handleSubmit, setFieldValue, values,  setFieldError, isSubmitting }) => (
                                <Form onSubmit={handleSubmit}>
                                    <div className={css.clsModalHeader}>
                                        <h2 className={css.clsModalTitle}> Team Member Profile</h2>
                                        <h5 className={classNames(css.clsModalSubTitle, css.clsReloadSubTitle, css.mw_651)}>
                                            {teamMemberDetails.userType === 'SCOUT' ?
                                                "Enter Profile and Account Information for Your Team Member" :
                                                "Enter Profile and Account Information and Usage Limitations for Your Team Member"
                                            }
                                        </h5>
                                    </div>

                                    <div className={classNames(css.clsModalBody)}>
                                        <div className="clearfix w-100">
                                            <div className="clearfix">
                                                <h4 className={css.clsRequiredTxt}>Indicates Required Field<span className={css.text_primary}>*</span></h4>
                                                <h4 className={classNames(css.clsModalSubTitle2, css.pb_16, "text-left")}> General Information </h4>

                                                <div className={classNames(css.rowInfo1, "flex-column-reverse flex-lg-row row")}>
                                                    <div className={classNames("col-lg-8 col-12")}>
                                                        <div className={classNames(css.clsFormGroup, css.mb_24)}>
                                                            <FormikText name="firstName" label="First Name" placeholder="First Name" errors={errors} touched={touched} required={true} />
                                                        </div>
                                                        <div className={classNames(css.clsFormGroup, css.mb_24)}>
                                                            <FormikText name="lastName" label="Last Name" placeholder="Last Name" errors={errors} touched={touched} required={true} />
                                                        </div>
                                                        <div className={classNames(css.clsFormGroup, css.mb_24)}>
                                                            <FormikText name="phone" label="Phone Number" placeholder="Phone Number" errors={errors} touched={touched} required={true}
                                                            maxLength={validationRules.maxLength.businessPhone}
                                                            validationPattern={validationRules.validationPattern.businessPhone}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className={classNames("col-lg-4 col-md-6 col-12")}>
                                                        <div className={classNames(css.clsFormGroup, "d-flex flex-column justify-content-center align-items-center")}>
                                                            <label className={classNames(css.clsFormLabel)}>  Profile Picture </label>
                                                            <div className={css.clsSelectProfileImg}>
                                                                <div className={css.clstProfileImg}>
                                                                    {imageUrl ? (
                                                                        <img src={getFullDataURL(imageUrl)} alt="Profile" />
                                                                    ) : (
                                                                        <img src={userImg} alt="Profile" />
                                                                    )}
                                                                </div>
                                                                <UploadProfilePicture key={imageUrl} label={imageUrl ? 'Edit Photo' : 'Add Photo'} filed={'profilePicture'} setFieldValue={setFieldValue} setImageUrl={setImageUrl} />
                                                                {imageUrl && (
                                                                    <a
                                                                        href="#"
                                                                        className={css.clsAddTxt}
                                                                        onClick={(e) => {
                                                                            e.preventDefault(); // Prevent page reload
                                                                            setImageUrl(null); // Clear image preview
                                                                            setFieldValue("profilePicture", []); // Set form value to null
                                                                        }}
                                                                    >
                                                                        Remove Photo
                                                                    </a>
                                                                )
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className={classNames(css.mt_48, "clearfix")}>
                                                    <h4 className={classNames(css.clsModalSubTitle2, css.pb_16, "text-left")}> Account Information </h4>
                                                    <div className={classNames(css.rowInfo2, css.mt_16, "row")}>
                                                        <div className={classNames(css.mb_24, "col-lg-6 col-12")}>
                                                            <div className={classNames(css.clsFormGroup)}>
                                                                <FormikText name="username" label="Email/Username" errors={errors} placeholder="Email Address" touched={touched} required={false} />
                                                            </div>
                                                        </div>
                                                        <div className={classNames(css.mb_24, "col-lg-6 col-12")}>
                                                            <div className={classNames(css.clsFormGroup)}>
                                                                <FormikText name="confirmEmail" label="Confirm Email/Username" errors={errors} placeholder="Confirm Email Address" touched={touched} required={false} />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className={classNames(css.rowInfo2, css.mt_16, "row")}>
                                                        <div className={classNames(css.mb_24, "col-lg-6 col-12")}>
                                                            <div className={classNames(css.clsFormGroup)}>
                                                                <FormikText name="newPwd" label="New Password" errors={errors} placeholder="New Password" touched={touched} required={false} type="password" hideErrorMsg={!isBlankTM} />
                                                                <PasswordStrength password={values.newPwd} email={values.username} fname={values.firstName} lname={values.lastName}  />
                                                            </div>
                                                        </div>
                                                        <div className={classNames("col-lg-6 col-12")}>
                                                            <div className={classNames(css.clsFormGroup)}>
                                                                <FormikText name="confirmPassword" label="Confirm New Password" errors={errors} placeholder="Confirm New Password" touched={touched} required={false} type="password" delayOnChangeValidation={800} avoidDelay={(val)=> val === values.newPwd} />
                                                                {values.confirmPassword && values.newPwd === values.confirmPassword && !errors?.confirmPassword ?  <p className={css.matchConfirmPassword}>Passwords Match</p> : null}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className={classNames(css.mt_48, "clearfix")}>
                                                    {teamMemberDetails.userType !== 'SCOUT' && (
                                                        <>
                                                            <h4 className={classNames(css.clsModalSubTitle2, css.pb_16, "text-left")}> Usage Limits </h4>
                                                            <div className={classNames(css.rowInfo2, css.mt_16, "row")}>
                                                                <div className={classNames(css.mb_24, "col-lg-6 col-12")}>
                                                                    <div className={classNames(css.clsFormGroup)}>
                                                                        <FormikText name="propertyLimit" label="Save Limit (Monthly)" errors={errors} placeholder="Save Limit (Monthly)" touched={touched} required={false} numbers={true} maxLength={12} type='text'   />
                                                                    </div>
                                                                </div>
                                                                <div className={classNames(css.mb_24, "col-lg-6 col-12")}>
                                                                    <div className={classNames(css.clsFormGroup)}>
                                                                        <FormikText name="spendingLimit" label="Spending Limit (Monthly)" errors={errors} placeholder="Spending Limit (Monthly)" touched={touched} required={false} numbers={true} maxLength={12} type='text' />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </div>

                                            {teamMemberDetails.userType !== 'SCOUT' && (<div className={classNames(css.mt_48, "clearfix")}>
                                                <h4 className={classNames(css.clsModalSubTitle2, css.mb_24, "text-left")}> Billing </h4>

                                                <div className={classNames(css.rowAddress, "row")}>
                                                    <div className={classNames(css.mb_24, "col-lg-6 col-12")}>
                                                        <div className={classNames(css.clsFormGroup)}>
                                                            <label className={classNames(css.clsFormLabel)}> Default for Subscriptions</label>
                                                            <CreditCardDropdown
                                                                tag={false}
                                                                options={cardList}
                                                                paymentMethodType={'Subscription'}
                                                                selectedId={values?.defaultSubsPaymentMethodId}
                                                                onChange={(selectedOption) => handleCardChange(selectedOption, 'defaultSubsPaymentMethodId', setFieldValue)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className={classNames(css.mb_24, "col-lg-6 col-12")}>
                                                        <div className={classNames(css.clsFormGroup)}>
                                                            <label className={classNames(css.clsFormLabel)}> Default For In App Purchases</label>
                                                            <CreditCardDropdown
                                                                tag={false}
                                                                paymentMethodType={'In-App Purchases'}
                                                                options={cardList}
                                                                selectedId={values?.defaultInAppPaymentMethodId}
                                                                onChange={(selectedOption) => handleCardChange(selectedOption, 'defaultInAppPaymentMethodId', setFieldValue)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>)}

                                            {teamMemberDetails.userType === 'TEAM_FULL' && (
                                                <div className={classNames(css.mt_48, "clearfix")}>
                                                    {hasListAutomatorSubscription && (
                                                        <>
                                                            <h4 className={classNames(css.clsModalSubTitle2, css.mb_24, "text-left")}>
                                                            Click to Dial
                                                            </h4>
                                                            <div className="row">
                                                            <div className={classNames("col-12")}>
                                                                <FormikCheckbox
                                                                name="allowClickToDial"
                                                                label={`Allow this user to make phone calls through ${getBrandName()}.`}
                                                                containerClassName={checkboxCSS.clsBatchDialerCheckbox}
                                                                labelClassName={checkboxCSS.clsBatchDialerLabel}
                                                                errors={errors}
                                                                touched={touched}
                                                                />
                                                            </div>
                                                            </div>
                                                        </>
                                                        )}
                                                    <h4 className={classNames(css.clsModalSubTitle2, css.mb_24, "text-left")}>Push to BatchDialer</h4>
                                                    <div className="row">
                                                        <div className={classNames("col-12")}>
                                                            <FormikCheckbox
                                                                name="pushToBatchDialer"
                                                                label="Allow this user to add leads to BatchDialer."
                                                                containerClassName={checkboxCSS.clsBatchDialerCheckbox}
                                                                labelClassName={checkboxCSS.clsBatchDialerLabel}
                                                                errors={errors}
                                                                touched={touched}
                                                            />
                                                        </div>
                                                    </div>
                                                    {hasInvestorOutreachSubscription && (
                                                        <>
                                                            <h4 className={classNames(css.clsModalSubTitle2, css.mb_24, "text-left")}>
                                                            Investor Outreach
                                                            </h4>
                                                            <div className="row">
                                                            <div className={classNames("col-12")}>
                                                                <FormikCheckbox
                                                                name="allowInvestorOutreach"
                                                                label="Allow this user to access Investor Outreach."
                                                                containerClassName={checkboxCSS.clsBatchDialerCheckbox}
                                                                labelClassName={checkboxCSS.clsBatchDialerLabel}
                                                                errors={errors}
                                                                touched={touched}
                                                                />
                                                            </div>
                                                            </div>
                                                        </>
                                                        )}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className={classNames(css.clsModalFooter, css.d_flex, css.justify_content_center)}>
                                        <button className={classNames(css.btn_lg, css.btn_primary, css.text_primary,)} onClick={handleClose}> Cancel</button>
                                        <button className={classNames(css.btn_lg, css.clsBtnOrng, css.ml_20)} type="submit" disabled={isSubmitting}>  Save </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>

                </div>
            </div>
        </Modal>
    );
};


const registrationId = getPopupRegistration(EditTeamProfilePopup);
EditTeamProfilePopup.open = (props = {}) => openPopup(registrationId, { ...props, priority: Priority.MEDIUM });
EditTeamProfilePopup.close = () => closePopup({ popup: registrationId });

export default EditTeamProfilePopup;
